import {Typography} from 'components/Typography';
import React, {FC, ReactNode} from 'react';
import style from './style.module.scss';

interface IProps {
    backgroundColor: string;
    children: ReactNode;
    color: string;
}

export const ShieldItem: FC<IProps> = ({backgroundColor, children, color}) => {
    return (
        <div className={style.main} style={{backgroundColor, color}}>
            <Typography variant={'label-10-b'}>{children}</Typography>
        </div>
    );
};
